import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchPagesComponent } from './search-pages.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { PageItemComponent } from './components/page-item/page-item.component';
import { AlertComponent } from '../../../../components/alert/alert.component';
import { LocalLoaderComponent } from '../../../../components/loader/local-loader/local-loader.component';
import { RouterModule } from '@angular/router';
import { CmsPageGuard, PageLayoutComponent, PaginationModule } from '@spartacus/storefront';

@NgModule({
  declarations: [SearchPagesComponent],
  imports: [
    CommonModule,
    I18nModule,
    PageItemComponent,
    AlertComponent,
    LocalLoaderComponent,
    RouterModule.forChild([
      {
        path: 'search-pages/:query',
        component: PageLayoutComponent,
        data: { pageLabel: 'search-pages' },
        canActivate: [CmsPageGuard],
      },
    ]),
    PaginationModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SearchPagesResultList: {
          component: SearchPagesComponent,
        },
      },
    }),
    provideConfig({
      routing: {
        routes: {
          searchPage: { paths: ['search-pages/:query'] },
        },
      },
    }),
  ],
})
export class SearchPagesModule {}
